import React, { FC } from 'react';

import { Divider, Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';

import { customTheme } from '../../../../../theme';

export const LearnMoreAboutAriksaOutposts: FC = () => {
  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="ariksa_outposts"
      headerTitle="Ariksa Outposts"
      body={
        <Stack spacing={6}>
          <Stack spacing={3}>
            <Text fontWeight={600} fontSize="xl">
              Ariksa Outpost For Vulnerability Management
            </Text>
            <Text>
              Ariksa Outpost for Vulnerabilities provides agentless scanning to
              identify software vulnerabilities present in your workloads and
              images. Outpost automatically scans virtual machines, containers,
              container images, serverless functions and machine images for
              software vulnerabilities, and overlays its unique risk context for
              every resource to automatically prioritize resources for patching.
              Ariksa assesses exploitability in a customized way for resources
              in your environment as part of a multi-layered assessment. This
              eliminates generalized vulnerabilities that either don’t affect
              your environment or do not apply to specific resources that don’t
              fully meet all criteria for exploitability. This significantly
              reducing operational overhead to patch and maintain a secure
              posture for your workloads.
            </Text>
          </Stack>
          <Text
            fontWeight={600}
            fontSize="xl"
            color={customTheme.colors.gray['250']}
          >
            Deployment
          </Text>
          <Text>
            For GCP and Azure, Ariksa Outpost for Vulnerabilities is deployed
            within one or more regions in your project or subscription. Outpost
            automatically scans all supported resources within the same region
            or zone to identify vulnerabilities. All Ariksa Outposts have
            permissions right-sized for the functionality that they deliver and
            strictly follow the principle of least privilege.
          </Text>

          <Divider />
          <Stack spacing={3}>
            <Text fontWeight={600} fontSize="xl">
              Ariksa Outpost For Data
            </Text>
            <Text>
              Ariksa Outpost for Data provides agentless scanning of data
              sources such as buckets, databases, and data warehouses, and SaaS
              (such as Snowflake) to automatically identify sensitive data and
              deliver robust data access and governance. Ariksa automatically
              classifies your data into categories and types such as PII, PCI,
              PHI. We also support classifying sensitive data into custom data
              types that you can define patterns for. This is particularly
              useful for data that is specific to your organization and holds
              context that’s required for data management, access and
              governance.
            </Text>
          </Stack>
          <Text>
            For unstructured data sources, such as buckets, Ariksa also delivers
            a more intelligent classification of content into document types
            (such as sales, marketing, financial etc.). This provides deeper and
            more intuitive context for what kind of documents you have and what
            sensitive data they have so that you can assess exposure and excess
            privileges for access to those documents. With document
            classification, you can better understand internal workflows or
            processes that impact documents with sensitive data.
          </Text>
          <Text>
            Once Ariksa Outpost is deployed all supported data sources are
            automatically scanned without any user intervention. However, you
            have the option to exclude one or more data sources from being
            scanned if desired.
          </Text>
          <Text
            fontWeight={600}
            fontSize="xl"
            color={customTheme.colors.gray['250']}
          >
            Deployment
          </Text>
          <Text>
            Ariksa Outpost for Data is deployed within your account so that all
            data that is scanned remains within your specified accounts and
            regions. This ensures no actual or real data from any of your data
            sources is transmitted to Ariksa SaaS. When Ariksa Outpost
            identifies sensitive data, it simply sends metadata information
            regarding the category and type of data to Ariksa SaaS for
            visibility and further actions. Under no circumstances, does Ariksa
            SaaS get access to your actual data to ensure that we completely
            enforce your privacy, data security and data sovereignty guidelines
            for existing and future data sources.
          </Text>
        </Stack>
      }
    />
  );
};
